import React from 'react';

import './BadgeButton.css';

type BadgeButtonProps = {
  label: string;
  isPrimary?: boolean;
  onClick?: () => void;
};

export const BadgeButton: React.FC<BadgeButtonProps> = ({
  label,
  onClick,
  isPrimary,
}) => {
  return (
    <button
      onClick={onClick}
      className={`badge-button ${isPrimary ? 'badge-button--primary' : ''}`}
    >
      {label}
    </button>
  );
};
